export default "/SMOLCOIN.acbd260ff1810c0b213b1bab984691a4.png";